interface ValuePropCardProps {
    imgSrc: string;
    imgAlt: string;
    title: string;
    description?: string;
}

export const ValuePropCard = ({
    imgSrc,
    imgAlt,
    title,
    description,
}: ValuePropCardProps) => {
    return (
        <div className="card bg-base-100 shadow-sm">
            <figure>
                {/* TODO(content): real marketing photo */}
                <img
                    src={imgSrc}
                    alt={imgAlt}
                    className="h-48 w-full object-cover"
                />
            </figure>
            <div className="card-body">
                <h3 className="card-title text-xl font-bold text-primary">
                    {title}
                </h3>
                {description && (
                    <p className="text-base text-primary">{description}</p>
                )}
            </div>
        </div>
    );
};
